import React from "react";
import { TText } from "./TableGrid";

const Text: React.FC<TText> = ({
  style,
  text,
  shouldBreakLine,
  marginRight,
  fontSize,
}) => {
  switch (style) {
    case "bold":
      return (
        <>
          <b style={{ display: "inline", marginRight, fontSize }}>{text}</b>
          {shouldBreakLine && <br />}
        </>
      );
    case "default":
      return (
        <>
          <p style={{ display: "inline", marginRight, fontSize }}>{text}</p>
          {shouldBreakLine && <br />}
        </>
      );
    case "faded":
      return (
        <>
          <span style={{ marginRight, fontSize }}>{text}</span>
          {shouldBreakLine && <br />}
        </>
      );
    case "alert":
      return (
        <>
          <span style={{ color: "var(--color-aux-danger-700)", marginRight, fontSize }}>
            {text}
          </span>
          {shouldBreakLine && <br />}
        </>
      );
    case "link":
      return (
        <>
          <span style={{ color: "var(--color-text-link)", marginRight, fontSize }}>
            {text}
          </span>
          {shouldBreakLine && <br />}
        </>
      );
    default:
      return (
        <>
          <span style={{ marginRight, fontSize }}>{text}</span>
          {shouldBreakLine && <br />}
        </>
      );
  }
};

export default Text;